import { render, staticRenderFns } from "./UserCurrentPlan.vue?vue&type=template&id=6cab16e6&"
import script from "./UserCurrentPlan.vue?vue&type=script&lang=js&"
export * from "./UserCurrentPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports